/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

// tslint:disable: only-arrow-functions

import * as moment from 'moment';

export const dateJar = (function() {
		const cache = { };
		return function dateJar(date, format) {
			if (!date) { return ''; }
			format = format || 'YYYY-MM-DD';
			if (cache[date] && cache[date][format]) { return cache[date][format]; }
			const fDate = moment(date).format(format);
			if (!cache[date]) { cache[date] = { }; }
			cache[date][format] = fDate;
			return fDate;
		};
})();
